const PLACEHOLDER_LABELS = new Set([
  'none',
  'null',
  'undefined',
  'unknown',
  'nil',
  'noabbreviation',
  'notavailable',
]);

function stripWrappingQuotes(value: string): string {
  return value.replace(/^[`"'“”‘’]+|[`"'“”‘’]+$/g, '');
}

function normalizedPlaceholderToken(value: string): string {
  return stripWrappingQuotes(value.trim())
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '');
}

export function isPlaceholderPlaceLabel(value?: string | null): boolean {
  if (!value) return false;

  const trimmed = stripWrappingQuotes(value.trim());
  if (!trimmed) return false;

  if (/^n\s*\/\s*a\.?$/i.test(trimmed)) {
    return true;
  }

  return PLACEHOLDER_LABELS.has(normalizedPlaceholderToken(trimmed));
}

export function cleanPlaceLabel(value?: string | null): string | undefined {
  if (!value) return undefined;

  const trimmed = stripWrappingQuotes(value.trim());
  if (!trimmed || isPlaceholderPlaceLabel(trimmed)) {
    return undefined;
  }

  return trimmed;
}
